export default "__VITE_ASSET__C$KBz6BV__"